<template>
  <v-progress-linear
    background-color="color_progress"
    :color="color(item)"
    class="rounded"
    dark
    :value="progress(item)"
    height="30px"
  >
    <template #default="">
      <div class="font-weight-bold">
        {{ item.lignesRob.traite }} /
        {{ item.lignesRob.total - item.lignesRob.annule }}
      </div>
    </template>
  </v-progress-linear>
</template>

<script>
export default {
  name: "VueMyProgressBar",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    progress(item) {
      return (
        (item.lignesRob.traite * 100) /
        (item.lignesRob.total - item.lignesRob.annule)
      );
    },
    color(item) {
      return item.lignesRob.traite !==
        item.lignesRob.total - item.lignesRob.annule
        ? "color_progress_end darken-1"
        : "color_progress_end";
    },
  },
};
</script>

<style scoped></style>
